<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title v-if="legis_exists">
      <v-row no-gutters>
        <span class="titlecapno text-h5 mr-3">{{capnum}}</span> 
        <span class="text-h2"> {{cur_ver ? cur_ver.title : ''}}</span>
      </v-row>

      <v-row no-gutters>
        <span class="titlecapno text-h5" :class="long_prov?'mr-3':''">{{long_prov}}</span>
        <span class="text-h4 mb-0">{{title}}</span>
      </v-row>
    </template>

    <template v-slot:leftPanel>

      <!--Legis Info Card-->
      <InfoTable
        :titleText="$t('database.wdg_legis')"
        :tableContent="infoTableContent"
        :contentType="'l_legis'"
      />

      <!--Reading Options Card-->
      <v-card id="readopcard" 
        v-if="!overlay && content_hl!==''" 
        class="pb-2 mb-3 lside-wdgt" 
        max-width="350" width="100%" color="lsidebg"
        flat
      >     
        <v-card-title class="pt-2 pb-1 pl-2">
          <h5 class="wdgt-title ">{{$t('database.wdg_viewops')}} </h5> <!--darkgrey--text-->
        </v-card-title>

        <v-card-actions class="pl-4 pb-1">
          <v-tooltip right :disabled="content_hl==''" color="liiblack lighten-1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dense outlined small color="link" 
                :disabled="content_hl==''"
                v-bind="attrs" v-on="on"
                @click="show_hl=!show_hl"
                class="mb-0">
                {{$t('btntxt.togglehl')}}
              </v-btn>
            </template>
            <span> {{$t('database.togglehl_hint')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

      <!--Compare Version Card-->
      <v-card id="comparecard" 
        v-if="versions.length>1"
        class="mb-3 hidden-sm-and-down d-print-none lside-wdgt" 
        max-width="350" width="100%" color="lsidebg"
        flat
      >           
        <v-card-title class="pt-2 pb-1 pl-2">
          <h5 class="wdgt-title">{{$t('database.version')}}</h5>
        </v-card-title>

        <v-card-actions class="ml-2">
          <v-btn 
            dense outlined small color="link" 
            @click="dialog=true"
            class="mb-2">
              {{$t('btntxt.compver')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>

    <template v-slot:mainPanel>

      <template v-if="legis_exists">
        <!--controls to pages-->
        <v-card flat class="pa-0 d-print-none lsidebg">
          <v-card-actions class="pa-0">

            <v-tooltip bottom color="liiblack lighten-1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-bind="attrs" 
                  :to="{path:presec}" 
                  v-on="on" 
                  color="link" 
                  text
                  class="link lighten-5 px-6" 
                  :disabled="!presec"
                >
                  <v-icon dark>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span>{{$t('database.totip_preSec')}}</span>
            </v-tooltip>
            <v-spacer></v-spacer>

            <v-btn 
              v-if="paths.length>1" 
              elevation="0" text color="link"
              class="link lighten-5 px-6" 
              :to="{path: tocpath}"
              active-class="no-active"
            >
              <v-icon v-show="!$vuetify.breakpoint.xs" small class="mr-4">mdi-format-list-bulleted </v-icon>
              <span v-if="$vuetify.breakpoint.xsOnly">{{ $t('btntxt.back') + $t('database.toc_short') }}</span>
              <span v-else>{{ $t('btntxt.back') + $t('database.toc') }}</span>
            </v-btn>

            <v-spacer></v-spacer>
            <v-tooltip bottom color="liiblack lighten-1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-bind="attrs" 
                  :to="{path:nextsec}" 
                  v-on="on" 
                  color="link"
                  text
                  class="link lighten-5 px-6"  
                  :disabled="!nextsec"
                >
                  <v-icon dark>mdi-chevron-right</v-icon>
                </v-btn></template>
              <span>{{$t('database.totip_nextSec')}}</span>
            </v-tooltip>

          </v-card-actions>
        </v-card>
          
          
        <!--version and lang toolbar-->
        <v-card flat class="pr-3 py-0 mt-5 mb-2 lsidebg d-print-none">
          <v-card-text class="px-3 py-2">
            <v-row no-gutters>
              <!--change version-->
              <v-select
                :items="versions"
                item-text="datestr"
                item-value="id"
                v-model="vid"
                :disabled="overlay"
                class="shrink"
                color="link"
                label="Version History"
                dense outlined hide-details
                @change="change_ver($event)"
                style="max-width: 400px; min-width: 250px;"
              />
              <v-spacer></v-spacer>
              <v-btn text color="link" class="ml-2" v-if="lang != 'en'" @click="go_trans('en')"> English</v-btn>
              <v-btn text color="link" class="ml-2" v-if="lang != 'tc'" @click="go_trans('tc')"> 繁體中文</v-btn>
              <v-btn text color="link" class="ml-2" v-if="lang != 'sc'" @click="go_trans('sc')"> 简体中文</v-btn>
            </v-row>
          </v-card-text>
        </v-card>

        <!--alert for past version-->
        <v-alert
          dense text
          type="warning"
          class="mt-0 mb-4 d-print-none"
          icon="mdi-alert-circle-outline"
          v-if="!is_latest"
        >
          <strong>{{$t('database.warning')}} </strong> <span class="pl-2"> {{$t('database.pastver')}}</span>
        </v-alert>
      </template>
          
      <!--alert for non-existing legis-->
      <v-alert 
        v-else-if="!overlay"
        dense text
        type="error"
        class="mt-0 mb-4 d-print-none"
        icon="mdi-alert-outline"
      > 
        {{$t('error.legis_unavailable')}}
      </v-alert>
          
      <!--loading overlay-->
      <v-skeleton-loader
        v-if="overlay"
        max-width="850"
        type="heading, sentences, list-item-two-line, list-item-three-line "
        class="d-print-none"
      ></v-skeleton-loader>

      
      <!--section content-->
      <div class="d-none d-print-inline pt-0 mt-0">
        <v-divider></v-divider>
        <span class="text-h2 print-version"> {{$t('database.version')}}: {{cur_ver ? display_date(cur_ver.date) : ''}}</span>
      </div>
      <div 
        v-if="legis_exists" v-html="show_hl&&$route.query.hl?content_hl:content" 
        class="case-content mt-6 mb-10 pl-md-2 pr-md-2 pl-lg-4 pr-lg-4" 
        @click="content_clicked">
      </div>

      <!--compare dialogue-->
      <v-dialog v-if="versions.length>1" v-model="dialog"  max-width="700px" class="d-print-none">
        <v-card class="pt-2 pb-5 pl-3 pr-4 popup">
          <v-card-title>
            <h4 class="text-h4 text-liiblack">{{ $t('database.compareversion') }} </h4>
          </v-card-title>

          <v-card-text class="mb-4">
            <v-row no-gutters>
              <v-col cols="5" xl="4">
                <v-select
                  :items="versions"
                  item-text="datestr"
                  item-value="id"
                  v-model="left"
                  :label="$i18n.t('database.version')+' 1'"
                  class="shrink mt-3 "
                  color="link"
                  dense outlined hide-details
                ></v-select>
              </v-col>

              <v-col cols="2" sm="1" class="d-flex justify-center align-center pt-2">
                <span class="wdgt_subtitle"> {{$t('database.filter_and')}} </span> 
              </v-col>

              <v-col cols="5" xl="4">
                <v-select
                  :items="versions"
                  item-text="datestr"
                  item-value="id"
                  v-model="right"
                  :label="$i18n.t('database.version')+ ' 2'"
                  class="shrink mt-3"
                  color="link"
                  dense outlined hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="darkgrey"
              class="white--text px-3"
              text 
              @click="dialog=false"
            >
              {{$t('btntxt.cancel')}}
            </v-btn>

            <v-btn
              color="link"
              elevation="0"
              class="white--text px-3"
              :disabled="!left || !right || left==right"
              @click="go_compare"
            >
              {{$t('btntxt.compver')}}
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </template>

    <template v-slot:rightPanel>
      <!--Noteup-->
      <v-card id="refcard" v-if="legis_exists" flat class="rsidecard mb-4 mr-3 pb-1" max-width="400" min-width="250" width="100%" > 
          
        <v-card-title class="mb-1">
          <h5 class="wdgt-title"> {{$t('database.wdg_ref_l')}} </h5>
        </v-card-title>

        <v-card-text class="pb-2">
          <v-tooltip bottom color="liiblack lighten-1">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn 
                  dense small block elevation="0"
                  color="primary white--text" 
                  :to="noteup_route"
                >
                  Noteup
                </v-btn>
        
              </div>
            </template>
            <span>{{$t('database.wdg_ref_noteup_legis')}}</span>
          </v-tooltip>
        </v-card-text>
      </v-card>

      <!--E legis Card-->
      <v-card id="elegiscard" v-if="legis_exists" flat class="rsidecard mb-4 mr-3 pb-1" max-width="400" min-width="250" width="100%" > 
          
        <v-card-title class="mb-1">
          <h5 class="wdgt-title"> {{$t('database.wdg_goto')}} </h5>
        </v-card-title>

        <v-card-text class="pb-2">
          <v-tooltip bottom color="liiblack lighten-1">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn 
                  dense small outlined block
                  color="navlink" 
                  target="_blank"
                  :href="elegislink"
                  >
                  {{$t('database.wdg_goto_elegis')}}
                </v-btn>

              </div>
            </template>
            <span>{{$t('database.wdg_goto_elegis_tooltip')}}</span>
          </v-tooltip>
        </v-card-text>
      </v-card>

    </template>

  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import InfoTable from '../components/InfoTable'
  import LangOpts from '../components/LangOpts'
  import DownloadWidget from '../components/DownloadWidget'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  import scrollhelper from '@/scripts/scrollhelper'
  import highlighthelper from '@/scripts/highlighthelper'
  export default {
    name: 'Section',
    data(){
      return {
        left: '',
        right: '',
        overlay: true,
        legis_exists: false,
        versions: [],
        sections: [],
        cur_ver: null,  // current version
        title: '',
        show_hl: true,  // highlight
        content: '',
        content_hl: '',  // content with highlight
        cap_title: null,
        num: '',
        order: null,
        vid: null,
        dialog: false,
        prov_num: '',
        presec: null,
        nextsec: null,
        pub_date: '',
      }
    },
    components:{
      ThreeColumn,
      InfoTable,
      LangOpts,
      DownloadWidget
    },
    watch: {
      '$i18n.locale': {
        handler: function(){
          this.versions = this.versions.map((i, index) => {
            i['datestr'] = datehelper.format_ver_time(i['date'])
            if (index === 0){
              i['datestr'] = `${i['datestr']} (${this.$t('database.wdg_legis_latest')})`
            }
            return i
          })
        },
        deep: true
      },
      '$route': function(){
        this.get_cap()
      },
      /*windowTitle: function(nv){
        window.document.title = nv
      }*/
    },
    computed:{
      lang(){
        return this.$route.params.lang
      },
      tocpath(){
        return this.$router.resolve({name: 'sectiontoc', params: this.$route.params}).href
      },
      capnum(){
        return this.num ? (this.$route.params.abbr=='instrument' ? 'Instrument ' : 'CAP ') + this.num : null
      },
      /*windowTitle(){
        return this.capnum + ' ' + this.long_prov + ' | HKLII'
      },*/
      paths(){
        if (this.legis_exists){
          const DB_NAMES = {
            en: {
              ord: "Hong Kong Ordinances",
              reg: "Hong Kong Regulations",
              instrument: "Hong Kong Constitutional Instruments",
            },
            tc: {
              ord: "香港條例",
              reg: "香港附屬法例",
              instrument: "香港憲法文件",
            },
            sc: {
              ord: "香港条例",
              reg: "香港附属法例",
              instrument: "香港宪法文件",
            },
          }
          var num = this.$route.params.num
          if (num.includes('_s')){
            num = num.slice(0, num.indexOf('_s'))
          }
          var db_name = DB_NAMES[this.lang][this.$route.params.abbr]
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
            {text: db_name, disabled: false, href: {name: 'legis-db', params: this.$route.params}},
            {text: this.capnum, disabled: false, href: {name: 'sectiontoc', params: this.$route.params}},
            {text: this.long_prov, disabled: true}
          ]
        } else {
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          ]
        }
      },
      long_prov(){
        var num = this.$route.params.num.toUpperCase()
        var prov_arr = num.split('_')
        if (!this.num){
          return null
        } else if (prov_arr.length === 1){
          return this.prov_num != '' ? this.prov_num : num
        } else {
          const ProvisionTypes = {
            en: {
              "P": "Part {0}",
              "SD": "Subdivision {0}",
              "D": "Division {0}"
            },
            tc: {
              "P": "第{0}部",
              "SD": "第{0}次分部",
              "D": "第{0}分部",
            },
            sc: {
              "P": "第{0}部",
              "SD": "第{0}次分部",
              "D": "第{0}分部",
            }
          }
          const regex = /(P|SD|D|)(\d+\w*)/
          var conv_prov = prov_arr.map((segment) => {
            var found = segment.match(regex)
            if (found){
              return ProvisionTypes[this.lang][found[1]].replace('{0}', found[2]) || ''
            } else {
              return segment
            }
          })
          return conv_prov.join(' - ')
        }
      },
      noteup_route(){
        return {
          name: 'legis-noteup',
          query: {
            'lang': this.$route.params.lang,
            'cap': this.$route.params.cap,
            'num': this.$route.params.num
          }
        }
      },
      infoTableContent(){
        var lastest_ver_date = this.versions.length > 0 ? datehelper.format_ver_time(this.versions[0]['date']) : ''
        var num_prov = this.capnum ? `${this.capnum} - ${this.long_prov}` : ''
        return [
          {name: this.$t('database.capno'), value: num_prov},
          // {name: this.$t('database.wdg_status'), value: 'Not yet in operation*'},
          {name: this.$t('database.wdg_legis_latest'), value: lastest_ver_date},
          {name: this.$t('database.wdg_legis_enact'), value: datehelper.display_date(this.pub_date)},
          {name: this.$t('database.wdg_legis_vercount'), value: this.versions.length}
        ]
      },
      is_latest(){
        return this.versions.map(ver => ver['id']).indexOf(this.vid) <= 0
      },
      elegislink(){
        if(!this.cur_ver) return 'https://www.elegislation.gov.hk'
        var link = 'https://www.elegislation.gov.hk/hk/cap' + this.num 
        link += (this.lang === 'tc' ? '!zh-Hant-HK' : this.lang=='sc' ? '!sc' : '')
        link += "@" + this.cur_ver.date.substring(0, this.cur_ver.date.indexOf('+'))
        return link
      }
    },
    methods:{
      display_date: datehelper.display_date,
      content_clicked: scrollhelper.content_clicked,
      store_local(){
        sessionStorage.setItem(this.num + '_' + this.lang, this.vid);
      },
      clear_local(){
        delete sessionStorage[this.$route.params.cap + '_' + this.lang]
      },
      fetch_local(){
        if (this.$route.params.cap + '_' + this.lang in sessionStorage){
          return parseInt(sessionStorage.getItem(this.$route.params.cap + '_' + this.lang))
        } else {
          return null
        }
      },
      async change_ver(event){
        this.overlay = true
        this.sections = []
        try {
          this.get_capsection()
          this.cur_ver = this.versions.find(ver => {return ver.id === this.vid})
        } catch(err) {
          console.error(err)
          this.legis_exists = false
        } finally {
          this.overlay = false
          this.store_local()
        }
      },
      go_compare(){
        this.$router.push({
          name:'compare',
          query:{left: this.left, right:this.right, num:this.$route.params['num']},
          params: this.$router.params  
        })
      },
      go_trans(lang){
        var params = {...this.$route.params, 'lang': lang}
        this.$router.push({name: 'section', params: params})
        this.get_cap()
      },
      async get_cap(){
        this.overlay = true
        var ls_vid = this.fetch_local()  // localstorage
        if(ls_vid){
          this.vid = ls_vid
        } else {
          this.vid = null
          this.sections = []
          this.clear_local()
        }
        try {
          const res = await api.get_secversions(this.lang, this.$route.params.abbr, this.$route.params.cap, this.$route.params.num)
          this.versions = res.map((i, index) => {
            i['datestr'] = datehelper.format_ver_time(i['date'])
            if (index === 0){
              i['datestr'] = `${i['datestr']} (${this.$t('database.wdg_legis_latest')})`
            }
            return i
          })
          this.vid = this.fetch_local()

          var vids = this.versions.map(ver => ver.id)
          if(this.vid == null || !vids.includes(this.vid)){
            this.vid = this.versions[0]['id']
          }
          this.cur_ver = this.versions.find(ver => {return ver['id'] === this.vid})
          this.num = this.$route.params.cap
          await this.get_capsection()
          this.legis_exists = true
          await this.$nextTick()
          scrollhelper.scroll_to_anchor(this.$route.hash)
        } catch(err) {
          console.error(err) 
          this.legis_exists = false
        } finally {
          this.overlay = false
        }
      },
      async get_capsection(){
        try {
          const res = await api.get_capsection(this.vid, this.$route.params.num)
          this.title = res['title']
          this.prov_num = res['prov_num']
          this.order = res['internal_order']
          this.content = res['content']
          this.pub_date = res['pub_date']
          if (this.$route.query.hl){
            this.content_hl = highlighthelper.hlBody(this.content, this.$route.query.hl)
          }
          await this.get_section_nav()
        } finally {
          this.store_local()
        }
      },
      async get_section_nav(){
        const res = await api.get_sectionnav(this.vid, this.order)
        this.presec = res.pre || null
        this.nextsec = res.next || null
      },
    },
    beforeMount(){
      this.get_cap()
    },
    metaInfo(){
      return{
        title: this.capnum + ' ' + this.long_prov || 'Legislation',
         meta: [
          {
            name: 'description',
            content: 'Contents of ' + this.capnum + ' ' + this.cur_ver.title + ' | ' + this.long_prov + ' ' + this.title,
          }
        ],
      }
    },
  }
</script>

<style lang="scss" scoped>
  .v-btn--active.no-active:not(:focus):not(:hover)::before{                                                                             
    opacity: 0 !important; /*keep nav button color*/
  }

  table {
    width: 100%;
  }

  a:hover {
    text-decoration-line: none;
  }

  .titlecapno {
    color: var(--v-footergrey-darken2);
    font-size: 12pt !important;
    font-weight: 700;
    display: inline-block;
    vertical-align: top;
     @media print{
      vertical-align: baseline;
      font-size:11pt;
     }
  }
  
  /*for printing, changes body text only, */
  .case-content, .sectiontoc{
    @media print{
      font-size: 9.5pt;
    }
  }
  #maincon {
    @media print{
      width:100%;
    }
  }
  .print-version { /*for version date - print only*/
    display: block;
    font-size:11pt;
  }

   @import '@/sass/_legis.scss';
</style>